import React, { useContext } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Grid from '@mui/material/Grid';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import { FormLabel, Switch, TextField } from '@mui/material';
import axios from "axios"
import { Box } from '@mui/system';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { AuthContext } from '../authContext/AuthContext';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const UpdateUser = ({updateDialog, handleClose, updateUserId}) => {
    const [username,setUsername] = React.useState("");
    const [email,setEmail] = React.useState("");
    const [name,setName] = React.useState("");
    const [phone,setPhone] = React.useState("");
    const [isAdmin,setIsAdmin] = React.useState(false);
    const [allowedShops,setAllowedShops] = React.useState([]);
    const [shops, setShops] = React.useState([]);
    const [disabled, setDisabled] = React.useState(false);
    const {user} = useContext(AuthContext)

    React.useEffect(() => {
      const getItem = async() => {
        if(updateUserId) {
          try {
            const res = await axios.get("/users/" + updateUserId, {headers: {token:"Bearer " + user.token}})
            setUsername(res.data.username)
            setEmail(res.data.email)
            setName(res.data.name)
            setPhone(res.data.phone)
            setIsAdmin(res.data.isAdmin)
            setAllowedShops(res.data.allowedShops)
          } catch (err) {
            console.log(err)
          }
        }
      };
      getItem();
    },[updateUserId, user]);

    React.useEffect(() => {
      const getShops = async() => {
        try {
          const res = await axios.get("/shops", {headers: {token:"Bearer " + user.token}})
          const checkedShops = [];
          res.data.map(shop => {
            let found = false
            if(allowedShops.length > 0) { 
              allowedShops.map((allowedShop) => {
                if (shop.shopkey === allowedShop.shopkey) {
                  found = true
                }
                return allowedShop
              });
            }
            checkedShops.push({...shop, checked: found})
            setShops(checkedShops)
            return shop
          });
        } catch (err) {
          console.log(err)
        }
      };
      getShops();
    },[allowedShops, user]);

    React.useEffect(() => {
      const validate = async() => {
        setDisabled(username.trim().length === 0
        || email.trim().length === 0
        || phone.trim().length === 0 )
      };
      validate();
    },[username, email, phone]);

    const updateUser = async() => {
      try {
        const checkedShops = [];
        shops.map(shop => {
          if (shop.checked) {
            const { checked, ...otherDetails } = shop;
            checkedShops.push(otherDetails)
          }
          return shop
        });
        setAllowedShops(checkedShops)
        const updateUser = {email, name, phone, isAdmin, allowedShops: checkedShops}
        await axios.put("/users/" + updateUserId, updateUser, {headers: {token:"Bearer " + user.token}})
        handleClose();
      } catch (err) {
        console.log(err)
      }
    };

    const handleChange = (updatedShop) => {
      const checkedShops = [];
      shops.map(shop => {
        if (shop.shopkey === updatedShop.shopkey) {
          checkedShops.push({...shop, checked: !shop.checked})
        } else {
          checkedShops.push(shop)
        }
        return shop
      });
      setShops(checkedShops)
    }
  return (
    <div>
      <Dialog
        open={updateDialog}
        onClose={handleClose}
        TransitionComponent={Transition}
        sx={{width: "100vw"}}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Update User
            </Typography>
          </Toolbar>
        </AppBar>
        <Box sx={{margin: "2vh"}}>
          <Grid container spacing={2}>
            <Grid item xs={12}><TextField label="User Name" variant="standard" fullWidth disabled value={username}/></Grid>
            <Grid item xs={12}><TextField label="Email" variant="standard" fullWidth value={email} onChange={(event)=> setEmail(event.target.value)}/></Grid>
            <Grid item xs={12}><TextField label="Display Name" variant="standard" fullWidth value={name} onChange={(event)=> setName(event.target.value)}/></Grid>
            <Grid item xs={12}><TextField label="Phone" variant="standard" fullWidth value={phone} onChange={(event)=> setPhone(event.target.value)}/></Grid>
            <Grid item xs={12}>
              <FormGroup>
                <FormControlLabel control={<Switch checked={isAdmin} onChange={()=> setIsAdmin(!isAdmin)}/>} label="Admin" />
              </FormGroup>
            </Grid>
            <Grid item xs={12}>
              <FormLabel component="legend">Allowed Shops</FormLabel>
              <FormGroup>
                {shops.map((shop) => (
                  <FormControlLabel key={shop.shopkey} control={<Checkbox name={shop.shopkey} checked={shop.checked} onChange={() => handleChange(shop)}/>} label={shop.shopname}/>
                ))}
              </FormGroup>
            </Grid>
            <Grid item xs={12}>
              <Button autoFocus variant="contained" onClick={updateUser} disabled={disabled} fullWidth>
              Update
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
    </div>
  )
}

export default UpdateUser
